import { ImportProgress as ImportProgressType } from '@/hooks/useImport';

interface ImportProgressProps {
  progress: ImportProgressType;
  entityType: string;
}

export function ImportProgress({ progress, entityType }: ImportProgressProps) {
  const percentage = Math.round((progress.processedRows / progress.totalRows) * 100);

  return (
    <div className="space-y-6 py-4">
      {/* Progress header */}
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
          <svg className="w-8 h-8 text-primary animate-spin" fill="none" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-foreground">Importing {entityType}...</h3>
        <p className="text-sm text-muted-foreground mt-1">Please wait while we process your data</p>
      </div>

      {/* Progress bar */}
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Progress</span>
          <span className="font-medium text-foreground">{percentage}%</span>
        </div>
        <div className="h-3 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-300 ease-out"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4">
        <div className="p-3 rounded-lg bg-muted/50 text-center">
          <p className="text-2xl font-bold text-foreground">{progress.processedRows}</p>
          <p className="text-xs text-muted-foreground">of {progress.totalRows} rows</p>
        </div>
        <div className="p-3 rounded-lg bg-muted/50 text-center">
          <p className="text-2xl font-bold text-foreground">{progress.currentBatch}</p>
          <p className="text-xs text-muted-foreground">of {progress.totalBatches} batches</p>
        </div>
      </div>

      {/* Note */}
      <p className="text-xs text-center text-muted-foreground">
        Processing in batches of 50 records to ensure reliability
      </p>
    </div>
  );
}
